<div aria-labelledby="contact-tab" class="tab-pane tab-content fade" id="day4" role="tabpanel">
    <FlashMessage></FlashMessage>
    <div class="container-fluid">
        <div class="content-block">
            <div class="error-list" v-if="ui.error.error_message">
                <ul class="error-msg">
                    <li :key="x" v-for="(error,x) in ui.error.error_message">
                        <div :key="i" v-for="(err,i) in error">
                            <p> {{err}}</p>
                        </div>
                    </li>
                </ul>
            </div>
            <form>
                <div class="empty-data green">
                    <p>
                        You can add, edit, or delete the highlight of the destination such as restaurant, parking,
                        Wi-Fi, etc.
                    </p>
                </div>
                <div v-if="!ui.status.canAdd && permission.trekHighlight_add">
                    <a @click.prevent="showAddHighlightButton()" class="btn default-btn" href=""><i
                            class="fas fa-plus"></i> Add new highlight</a>
                </div>
                <div class="form-modified">
                    <div class="form-group row" v-if="ui.status.canAdd">
                        <label class="col-sm-2 col-form-label" for="staticEmail">
                            Highlights</label>
                        <div class="col-sm-8">
                            <div class="form-group">
                <textarea :class="{ 'error-input' : ui.error.errors['description'] }" id="" name=""
                          placeholder="eg. Special highlights of the place"
                          v-model="item.addHighlight.description"></textarea>
                                <validation-error :errors="ui.error.errors" :field="'description'"
                                                  :isError="ui.error.has_error" v-if="ui.error.has_error"/>

                            </div>


                            <div class="form-group">
                                <div class="multiselect-input" v-if="getAllIconsList">
                                    <multiselect :class="{ 'error-input' : ui.error.errors['icon_id'] }"
                                                 :custom-label="customLabel"
                                                 :option-height="40" :options='getAllIconsList' :show-labels="false"
                                                 :track-by="'name'" label="name"
                                                 placeholder="Choose icon" v-model="item.addHighlight.icon">
                                        <template slot="singleLabel" slot-scope="props"
                                        ><img
                                                :src="props.option.icon_path"
                                                alt="No Man’s Sky"
                                                class="option__image"
                                        /><span class="option__desc"
                                        ><span class="option__title"
                                        >{{ props.option.name }}</span
                                        ></span
                                        ></template
                                        >
                                        <template slot="option" slot-scope="props"
                                        ><img
                                                :src="props.option.icon_path"
                                                alt="No Man’s Sky"
                                                class="option__image"
                                        />
                                            <div class="option__desc">
                        <span class="option__title"
                        >{{ props.option.name }}</span
                        >
                                            </div>
                                        </template>
                                    </multiselect>
                                    <validation-error :errors="ui.error.errors" :field="'icon_id'"
                                                      :isError="ui.error.has_error" v-if="ui.error.has_error"/>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-2" v-if="permission.trekHighlight_add">
                            <a @click.prevent="createHighlight" class="btn btn-sm add-btn" href="#" role="button">
                                {{buttonTextAddHighlight}}
                                <spinner :loading="ui.status.postLoading.create" v-if="ui.status.postLoading.create"></spinner>
                            </a>
                        </div>

                    </div>
                    <div :key="index" class="form-group row" v-for="(list, index) in item.highlightsList"
                         v-if="item.highlightsList">
                        <div class="col-sm-8 offset-2">
                            <div class="includes">
                                <div class="includes-list-item  py-0 pr-0">

                                    <div class="includes-list hoverable-list readonly py-3">
                                        <div class="list-ico">
                                            <img :src="list.icon.icon_path" v-if="list.icon">
                                        </div>
                                        <p>{{ list.description }}</p>
                                        <div class="up-down">
                                            <button @click.prevent="moveHighlightUp(index, list)"
                                                    class="btn arrange-btn"
                                                    v-if="index != 0"><i
                                                    class="fas fa-level-up-alt"></i></button>
                                            <button @click.prevent="moveHighlightDown(index, list)"
                                                    class="btn arrange-btn"
                                                    v-if="index !== item.highlightsList.length -1"><i
                                                    class="fas fa-level-down-alt"></i></button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <div class="includes-action">
                                <button v-if="permission.trekHighlight_edit" @click.prevent="onEditHighlightsClick(index, list)" class="btn" type="button">
                                    <i class="fas fa-pen"></i>
                                    </a>
                                </button>
                                <button v-if="permission.trekHighlight_delete" @click.prevent="onDeleteHighlightsClick(index, list)" class="btn red" type="button">
                                    <i class="fas fa-trash-alt"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="empty-data" v-if="item.highlightsList.length == 0">
                        <p>No Highlight List</p>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="modal-wrap">
        <div aria-labelledby="exampleModalLabel" class="modal fade show" id="edithighlights" role="dialog"
             tabindex="-1">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">

                        <h5 class="modal-title">Edit Highlight</h5>
                        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="error-list" v-if="ui.error.modal.edit">
                        <ul class="error-msg">
                            <li :key="x" v-for="(error,x) in ui.error.modal.edit">
                                <div :key="i" v-for="(err,i) in error">
                                    <p> {{err}}</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="modal-body">
                        <div class="form-modified">
                            <div class="form-group">
                <textarea :class="{ 'error-input' : ui.error.errors['edit_description'] }" class="form-control" id=""
                          name="" placeholder="eg. Special highlights of the place"
                          v-model="item.editHighlight.description"></textarea>
                                <validation-error :errors="ui.error.errors" :field="'edit_description'"
                                                  :isError="ui.error.has_error" v-if="ui.error.has_error"/>
                            </div>
                            <div class="form-group">
                                <div class="multiselect-input" v-if="getAllIconsList">
                                    <multiselect :class="{ 'error-input' :  ui.error.errors['edit_icon_id'] }"
                                                 :custom-label="customLabel" :option-height="40"
                                                 :options='getAllIconsList' :show-labels="false" :track-by="'name'"
                                                 label="name"
                                                 placeholder="Choose icon"
                                                 v-model="item.editHighlight.icon">
                                        <template slot="singleLabel" slot-scope="props"><img
                                                :src="props.option.icon_path"
                                                alt="No Man’s Sky"
                                                class="option__image"><span
                                                class="option__desc"><span
                                                class="option__title">{{ props.option.name }}</span></span></template>
                                        <template slot="option" slot-scope="props"><img :src="props.option.icon_path"
                                                                                        alt="No Man’s Sky"
                                                                                        class="option__image">
                                            <div class="option__desc"><span class="option__title">{{ props.option.name }}</span>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <validation-error :errors="ui.error.errors" :field="'edit_icon_id'"
                                                      :isError="ui.error.has_error" v-if="ui.error.has_error"/>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button @click.prevent="updateHighlight" class="btn default-btn" type="button">Save
                            <spinner :loading="ui.status.postLoading.update" v-if="ui.status.postLoading.update"></spinner>
                        </button>
                        <button :disabled="ui.status.postLoading.update" @click.prevent="hideUpdateHighlightModal"
                                aria-label="Close"
                                class="btn default-btn cancel" type="button">Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-wrap">
        <div aria-labelledby="exampleModalLabel" class="modal fade show" id="delete" role="dialog" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Delete Highlight</h5>
                        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="error-list" v-if="ui.error.modal.delete">
                        <ul class="error-msg">
                            <li :key="x" v-for="(error,x) in ui.error.modal.delete">
                                <div :key="i" v-for="(err,i) in error">
                                    <p> {{err}}</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="modal-body">
                        <p>Are you sure you want to delete this ?</p>
                    </div>

                    <div class="modal-footer">
                        <button @click.prevent="deleteHighlight" class="btn default-btn" type="button">Ok
                            <spinner :loading="ui.status.postLoading.delete" v-if="ui.status.postLoading.delete"></spinner>
                        </button>
                        </button>
                        <button :disabled="ui.status.postLoading.delete" @click.prevent="hideDeleteHighlightModal" aria-label="Close"
                                class="btn default-btn cancel" type="button">Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
